import React, { useEffect, useRef } from 'react';

interface CollapseProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  buttonContent: string | React.ReactNode;
  children?: React.ReactNode;
  isActive?: boolean;
  onClick?: () => void;
  index?: number;
}

export const Collapse: React.FC<CollapseProps> = ({
  buttonContent,
  children,
  isActive = false,
  onClick,
  index = 0,
  ...otherProps
}) => {
  const collapseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (typeof (window as any).mzAnimator === 'object') {
      function setHeight() {
        (window as any).mzAnimator.animateHeight(collapseRef.current, 'CollapseDealer' + index, 'init');
        if ((window as any).mzAnimator.heightOrigin['CollapseDealer' + index] === 0) {
          setTimeout(setHeight, 100);
        }
      }
      setHeight();
    }
  }, [index]);

  useEffect(() => {
    if (typeof (window as any).mzAnimator === 'object') {
      (window as any).mzAnimator.animateHeight(collapseRef.current, 'CollapseDealer' + index, isActive);
    }
  }, [isActive, index]);
  
  return (
    <div className={`${(window as any).bnp_retailer_mode ? '' : 'mz-collapse mz-collapse-forms mzReactForms-component'}`}>
      <button
        onClick={() => {
          if (onClick) {
            onClick();
          }
        }}
        className={`mz-collapse__button ${!isActive ? '' : 'active'}`}
        {...otherProps}
      >
        {buttonContent}
        {!(window as any).bnp_retailer_mode && <i className={`mz-svg mz-svg-chevroncarousel mz-svg--grey${isActive ? 'visible' : ''}`}></i>}
      </button>
      <div className="mz-collapse__box visible" ref={collapseRef}>
        {children}
      </div>
    </div>
  );
};

export default Collapse;
